module.exports = __webpack_public_path__ + "img/down.d99b74d7.svg";